import React from 'react';
import { Box, CardActions } from '@mui/material';
import OfferStatusChips from '../../../OfferStatusChips';

const OfferMeta = ({
  active,
  quantity,
  endDate,
  isPreview,
  showUnavailableLabels = false,
  unlimitedClaims = false,
}) => {
  return (
    <CardActions disableSpacing>
      <Box display="flex" justifyContent="space-between" width="100%">
        <OfferStatusChips
          active={active}
          claimsRemaining={quantity}
          endDate={endDate}
          isPreview={isPreview}
          showUnavailableLabels={showUnavailableLabels}
          unlimitedClaims={unlimitedClaims}
        />
      </Box>
    </CardActions>
  );
};

export default OfferMeta;
